import React from 'react';
function Properties() {

  return (
    <div className="properties">
    </div>
  );
}

export default Properties;